// extracted by mini-css-extract-plugin
export var indeterminate = "_1v-6";
export var md = "_1v-5";
export var semantic = "_1v-7";
export var sm = "_1v-4";
export var text = "_1v-8";
export var toggleControl = "_1v-0";
export var toggleInput = "_1v-1";
export var toggleSwitch = "_1v-2";
export var xs = "_1v-3";